import { Component, DOCUMENT, inject, OnInit } from '@angular/core';
import { FadeInReveal } from '../../../../directives/fade-in-reveal';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-service-adult',
  imports: [CommonModule, RouterLink, FadeInReveal],
  templateUrl: './service-adult.html',
  styleUrls: ['./service-adult.less', '../services.less'],
})
export class ServiceAdult implements OnInit {
  private dom = inject(DOCUMENT);

  ngOnInit() {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Terapia para adultos',
      description:
        'Terapia psicológica para adultos orientada a ansiedad, autoestima, toma de decisiones y bienestar emocional.',
      provider: { '@id': 'https://anapellonpsicologa.com' },
      areaServed: [
        {
          '@type': 'AdministrativeArea',
          name: 'Santander',
        },
        {
          '@type': 'Country',
          name: 'España',
        },
      ],
      availableChannel: [
        {
          '@type': 'ServiceChannel',
          serviceLocation: {
            '@type': 'Place',
            name: 'Consulta presencial en Santander',
          },
        },
        {
          '@type': 'ServiceChannel',
          serviceUrl: 'https://anapellonpsicologa.com/contacto',
        },
      ],
    };

    const script = this.dom.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    this.dom.head.appendChild(script);
  }
}
